
function installVueGlobal(Vue, globalName, globalValue) {
  const globalPrototype = Vue.version.slice(0, 2) === '3.' ? Vue.config.globalProperties : Vue.prototype;

  // Don't use Object.assign() to match the Vue.js supported browsers (ECMAScript 5)
  globalPrototype[globalName] = globalValue;
}

const stringUtils = {
  truncate(str, length = 15) {
    if (!str) return '';
    return str.length > length ? str.slice(0, length) + '...' : str;
  },
}

export default function install(Vue) {
  installVueGlobal(Vue, '$stringUtils', stringUtils);
}